import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Menu } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const dashboardPath = () => {
    if (!user) return "/login";
    if (user.role === "super_admin") return "/admin";
    return "/gestor";
  };

  return (
    <header className="sticky top-0 z-40 bg-slate-900/90 backdrop-blur-md border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center">
          <div className="bg-white rounded-lg px-2 py-1">
            <img src="/vixvox-mark.png" alt="VixVox" className="h-9 w-auto" data-testid="brand-logo" />
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-300">
          <Link to="/vixvox" className="hover:text-white transition-colors" data-testid="nav-sobre">VixVox</Link>
          <a href="/#features" className="hover:text-white transition-colors" data-testid="nav-features">Recursos</a>
          <a href="/#compliance" className="hover:text-white transition-colors" data-testid="nav-compliance">Conformidade</a>
          <a href="/#pricing" className="hover:text-white transition-colors" data-testid="nav-pricing">Planos</a>
          <Link to="/acompanhar" className="hover:text-white transition-colors" data-testid="nav-followup">Acompanhar denúncia</Link>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user && user.role ? (
            <>
              <Button variant="ghost" onClick={() => nav(dashboardPath())} data-testid="nav-dashboard-btn" className="text-slate-200 hover:bg-slate-800">
                Painel
              </Button>
              <Button variant="outline" onClick={() => { logout(); nav("/"); }} data-testid="nav-logout-btn" className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800">
                <LogOut className="w-4 h-4 mr-2" /> Sair
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={() => nav("/login")} data-testid="nav-login-btn" className="text-slate-200 hover:bg-slate-800">Entrar</Button>
              <Button onClick={() => nav("/registro")} data-testid="nav-register-btn" className="bg-indigo-600 hover:bg-indigo-700 text-white">
                Começar agora
              </Button>
            </>
          )}
        </div>

        <button className="md:hidden text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          <Menu className="w-6 h-6" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-800 bg-slate-900 px-4 py-4 space-y-3">
          <Link to="/vixvox" className="block text-slate-200" onClick={() => setOpen(false)} data-testid="mnav-sobre">VixVox</Link>
          <Link to="/acompanhar" className="block text-slate-200" onClick={() => setOpen(false)} data-testid="mnav-followup">Acompanhar denúncia</Link>
          {user && user.role ? (
            <>
              <Link to={dashboardPath()} className="block text-slate-200" data-testid="mnav-dashboard">Painel</Link>
              <button className="text-slate-200" onClick={() => { logout(); nav("/"); }} data-testid="mnav-logout">Sair</button>
            </>
          ) : (
            <>
              <Link to="/login" className="block text-slate-200" data-testid="mnav-login">Entrar</Link>
              <Link to="/registro" className="block text-indigo-400 font-semibold" data-testid="mnav-register">Começar agora</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
